<template>
  <div id="print-template">
    <div class="WordSection1">
      <!-- <style>
        @media print {
          body {
            width: 21cm;
            height: 29.7cm;
            margin: 30mm 45mm 30mm 45mm;
            /* change the margins as you want them to be. */
          }
        }
      </style> -->
      <p class="MsoNormal" align="center" style="text-align:center">
        <b
          ><span style="font-size:16.0pt;line-height:115%"
            >TANDA TERIMA BERKAS TAGIHAN</span
          ></b
        >
      </p>

      <table
        class="MsoTableGrid"
        border="0"
        cellspacing="0"
        cellpadding="0"
        style="border-collapse:collapse;border:none"
      >
        <tr>
          <td
            width="212"
            valign="top"
            style="width:126.9pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              Jenis SPM
            </p>
          </td>
          <td
            width="23"
            valign="top"
            style="width:13.75pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              :
            </p>
          </td>
          <td
            width="564"
            valign="top"
            style="width:338.15pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              {{ form.NamaSPM }}
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="212"
            valign="top"
            style="width:126.9pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              No SPM
            </p>
          </td>
          <td
            width="23"
            valign="top"
            style="width:13.75pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              :
            </p>
          </td>
          <td
            width="564"
            valign="top"
            style="width:338.15pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              {{ form.NoDPA }}
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="212"
            valign="top"
            style="width:126.9pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              Tanggal SPM
            </p>
          </td>
          <td
            width="23"
            valign="top"
            style="width:13.75pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              :
            </p>
          </td>
          <td
            width="564"
            valign="top"
            style="width:338.15pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              {{ form.TglDPAF }}
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="212"
            valign="top"
            style="width:126.9pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              NIlai SPM
            </p>
          </td>
          <td
            width="23"
            valign="top"
            style="width:13.75pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              :
            </p>
          </td>
          <td
            width="564"
            valign="top"
            style="width:338.15pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              {{ form.NilaiTermin }}
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="212"
            valign="top"
            style="width:126.9pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              Uraian Pembayaran
            </p>
          </td>
          <td
            width="23"
            valign="top"
            style="width:13.75pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              :
            </p>
          </td>
          <td
            width="564"
            valign="top"
            style="width:338.15pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
              v-html="form.Keterangan"
            ></p>
          </td>
        </tr>
        <tr>
          <td
            width="212"
            valign="top"
            style="width:126.9pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              Penerima Pembayaran
            </p>
          </td>
          <td
            width="23"
            valign="top"
            style="width:13.75pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              :
            </p>
          </td>
          <td
            width="564"
            valign="top"
            style="width:338.15pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              {{ form.Penerima }}
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="212"
            valign="top"
            style="width:126.9pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              Bidang/Balai Pengirim
            </p>
          </td>
          <td
            width="23"
            valign="top"
            style="width:13.75pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              :
            </p>
          </td>
          <td
            width="564"
            valign="top"
            style="width:338.15pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              style="margin-bottom:0in;margin-bottom:.0001pt;line-height:
                      normal"
            >
              {{ form.NamaBalai }}
            </p>
          </td>
        </tr>
      </table>

      <p class="MsoNormal">&nbsp;</p>

      <table
        class="MsoTableGrid"
        border="0"
        cellspacing="0"
        cellpadding="0"
        style="border-collapse:collapse;border:none"
      >
        <tr>
          <td
            width="399"
            valign="top"
            style="width:239.4pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              &nbsp;
            </p>
          </td>
          <td
            width="399"
            valign="top"
            style="width:239.4pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              Semarang, {{ form.TglDPAF }}
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="399"
            valign="top"
            style="width:239.4pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              Pengirim,
            </p>
          </td>
          <td
            width="399"
            valign="top"
            style="width:239.4pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              Penerima,
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="399"
            valign="top"
            style="width:239.4pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              &nbsp;
            </p>
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              &nbsp;
            </p>
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              &nbsp;
            </p>
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              <br />
              <br />
              <br />
              <br />
              <br />
              ………………………………………..
            </p>
          </td>
          <td
            width="399"
            valign="top"
            style="width:239.4pt;padding:0in 5.4pt 0in 5.4pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              &nbsp;
            </p>
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              &nbsp;
            </p>
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              &nbsp;
            </p>
            <p
              class="MsoNormal"
              align="center"
              style="margin-bottom:0in;margin-bottom:.0001pt;
                      text-align:center;line-height:normal"
            >
              <br />
              <br />
              <br />
              <br />
              <br />
              ………………………………………..
            </p>
          </td>
        </tr>
      </table>

      <p class="MsoNormal">&nbsp;</p>

      <p class="MsoNormal">&nbsp;</p>
    </div>
  </div>
</template>
<script>
export default {
  //   data: () => ({
  //     form: {},
  //   }),
  props: {
    form: Object,
  },
}
</script>
